const objFunc = () => {
  return {
    handlers: {},
    props: {}
  }
}

export default objFunc()

export const defaultObj = objFunc()
